import styled from 'styled-components'
import { Button, Col, Table } from 'antd'
import { colors } from './constants'

export const AlignRightColumn = styled(Col)`
  display: flex !important;
  justify-content: flex-end;
`
export const AlignLeftColumn = styled(Col)`
  display: flex !important;
  justify-content: flex-start;
`

export const MarginLeftButton = styled(Button)`
  margin-left: 1rem;
`

export const WhiteTable = styled(Table)`
  & .ant-table {
    background: ${colors.white};
  }
`

export const MarginBottonContainer = styled.div`
  margin-bottom: 1rem;
`

export const UppercaseP = styled.p`
  text-transform: uppercase;
`



// WEBPACK FOOTER //
// ./src/common/styled.js